import http from '@/js/http';
import { IUpdateUserRequest } from './request.interface';
import { GetSigningKeyResponse, User, UserCreateRequest } from '@/types';

export const UserService = {
    async get(id: string) {
        const { data } = await http.get<User>(`/users/${id}`);
        return data;
    },

    async create(payload: UserCreateRequest) {
        const { data } = await http.post<User>(`/users`, payload);
        return data;
    },

    async update(id: string, payload: IUpdateUserRequest) {
        const { data } = await http.put<User>(`/users/${id}`, payload);
        return data;
    },

    async notify(id: string, { title, body, url }: { title: string; body: string; url: string }) {
        return await http.post(`/users/${id}/notify`, {
            title,
            body,
            url,
        });
    },

    async getSigningKey(id: string | number) {
        const { data } = await http.post<GetSigningKeyResponse>(`/admin/users/${id}/token`);
        return data;
    },

    // active: api('/api/users/{userId}/active', 'post'),

    // updateCreditLimit: api('/api/users/{userId}/credit-limit', 'post'),
};
